import { Flex, Text } from "@chakra-ui/react";
import { IActivityLog } from "@publishing-engine/domain/models";

export const ManuscriptIdDetails: React.FC<{
  changes: IActivityLog['changes'];
  type?: 'TransferOfferAccepted'
}> = ({ changes }) => {

  const getValue = (fieldName: string) => {
    return changes?.length
      ? changes.find(obj =>
        Object.prototype.hasOwnProperty.call(obj, fieldName)
      )?.[fieldName] as string
      : '';
  }

  const sourceJournal = getValue('submission.oldJournalName')
  const transferredJournal = getValue("submission.transferredJournalName")
  const oldManuscriptId = getValue('submission.oldManuscriptId');
  const newManuscriptId = getValue('submission.manuscriptId')

  return (
    <>
      {sourceJournal && transferredJournal && <Flex direction='column' gap={2}>
        <Text textStyle="textContext">Original ID (from {sourceJournal}): {oldManuscriptId}</Text>
        <Text textStyle="textContext">New ID (from transfer to {transferredJournal}): {newManuscriptId}</Text>
      </Flex>}
    </>
  )
}